/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('DOMContentLoaded', function () {
  const variantEl = document.querySelector('input[name="id"], select[name="id"]');
  const klTrigger = document.querySelector('.klaviyo-bis-trigger');

  if (!variantEl || !klTrigger) return;

  let lastVariantId = variantEl.value;

  function resetKlaviyo() {
    // Force destroy old state
    if (window._klOnsite) {
      window._klOnsite.push(['unsubscribe']);
      window._klOnsite.push(['reset']);
    }

    // Trigger refresh on the current variant
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['refresh']);

    console.log('[Klaviyo] Reset and refreshed for variant ID: ' + variantEl.value);
  }

  function watchVariantChange() {
    const newId = variantEl.value;
    if (newId !== lastVariantId) {
      lastVariantId = newId;
      resetKlaviyo();
    }
  }

  // Delay initial trigger to ensure variant has settled
  setTimeout(() => {
    resetKlaviyo();
  }, 300);

  // Observe input or select value change (covers theme-driven updates)
  const observer = new MutationObserver(watchVariantChange);
  observer.observe(variantEl, { attributes: true, attributeFilter: ['value'] });

  // Fallback for manual change events
  variantEl.addEventListener('change', resetKlaviyo);
});



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
